import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { CompanyDetailsComponent } from '../../components/company-details/company-details.component';

@Injectable({
    providedIn: 'root'
})
export class CompanyEditGuard implements CanDeactivate<CompanyDetailsComponent> {
    canDeactivate(component: CompanyDetailsComponent): Observable<boolean> | Promise<boolean> | boolean {
        if (component.companyForm.touched && component.companyForm.dirty) {
            return confirm(`Are you sure you want to navigate away and discard your changes?`);
        }
        return true;
    }
}
